/**
 * decodeVinModelYear — Modelljahr aus der 10. Stelle der 17-stelligen FIN/VIN.
 *
 * Jul-2026 (User-Wunsch, Tabelle vom User) — ISO-3779-Verschlüsselung. Der Code
 * wiederholt sich in einem 30-Jahres-Zyklus, daher ist das Modelljahr NICHT
 * exakt mit dem Baujahr identisch → das Feld ist als „unverbindlich" zu behandeln.
 *
 * Tabelle (10. Stelle → Modelljahr, primärer Zyklus 1980–2009):
 *   A=1980 B=1981 C=1982 D=1983 E=1984 F=1985 G=1986 H=1987 J=1988 K=1989
 *   L=1990 M=1991 N=1992 P=1993 R=1994 S=1995 T=1996 V=1997 W=1998 X=1999 Y=2000
 *   1=2001 2=2002 3=2003 4=2004 5=2005 6=2006 7=2007 8=2008 9=2009
 * Buchstaben I, O, Q, U und die Ziffer 0 werden nicht verwendet.
 */

const PRIMARY = (() => {
    const map = {};
    const letters = "ABCDEFGHJKLMNPRSTVWXY"; // ohne I,O,Q,U,Z
    letters.split("").forEach((ch, i) => { map[ch] = 1980 + i; }); // A=1980 … Y=2000
    for (let d = 1; d <= 9; d++) map[String(d)] = 2000 + d; // 1=2001 … 9=2009
    return map;
})();

/** Liefert das plausibelste Modelljahr für ein FIN-Zeichen (10. Stelle). */
export function modelYearForChar(char) {
    if (!char) return null;
    const c = char.toUpperCase();
    const base = PRIMARY[c];
    if (base === undefined) return null;
    const maxYear = new Date().getFullYear() + 1; // ein Modelljahr im Voraus zulässig
    // Kandidaten im 30-Jahres-Zyklus; nimm das jüngste, das nicht in der Zukunft liegt.
    let best = base;
    for (let k = -1; k <= 3; k++) {
        const cand = base + 30 * k;
        if (cand <= maxYear && cand >= 1970 && cand > best - 1) {
            if (cand <= maxYear && (best > maxYear || cand > best)) best = cand;
        }
    }
    // Falls best noch in der Zukunft (z.B. base 2010 aber maxYear 2027 → ok),
    // ansonsten das größte <= maxYear wählen.
    let chosen = null;
    for (let k = -1; k <= 3; k++) {
        const cand = base + 30 * k;
        if (cand <= maxYear && (chosen === null || cand > chosen)) chosen = cand;
    }
    return chosen;
}

/**
 * Dekodiert das Modelljahr aus einer vollständigen 17-stelligen FIN.
 * @returns {{ year: number|null, char: string|null, valid: boolean }}
 */
export function decodeVinModelYear(vin) {
    const v = (vin || "").toString().trim().toUpperCase().replace(/\s/g, "");
    if (v.length < 10) return { year: null, char: null, valid: false };
    const char = v.charAt(9); // 10. Stelle (Index 9)
    const year = modelYearForChar(char);
    return { year, char, valid: v.length === 17 && year !== null };
}

export default decodeVinModelYear;
